import { PointHelper } from "@opstel/geo/helpers/PointHelper";
import { Point } from "@opstel/geo/Point";
import { useMemo } from "react";
import { Path as PathKonva } from "react-konva";

type PlanTrainUnitUnitEndShapeProps = {
  readonly points: Point[];
  readonly fill: string;
  readonly width: number;
  readonly position: "first" | "last";
};

//  https://yqnn.github.io/svg-path-editor/
const shapes = {
  default:
    "M-.66-.3301C-.66-.6946-.3645-1 0-1L.05-1 .05 1 0 1C-.3645 1-.66.6945-.66.3299L-.66-.3301",
  front: "M-.88-.11C-.88-.596-.486-1 0-1L.05-1 .05 1 0 1C-.486 1-.88.596-.88.11Z",
};

export function PlanTrainUnitUnitEndShape({
  points,
  fill,
  width,
  position,
}: PlanTrainUnitUnitEndShapeProps) {
  const [point, rotation] = useMemo(() => {
    const [index, secondIndex] =
      position === "first" ? [0, 1] : [points.length - 1, points.length - 2];
    const point = points[index];
    const secondPoint = points[secondIndex];
    const rotation = PointHelper.getRotation(point, secondPoint);
    return [point, rotation];
  }, [points, position]);

  const scale = { x: width / 2, y: width / 2 };

  return (
    <PathKonva
      data={shapes.default}
      x={point.x}
      y={point.y}
      fill={fill}
      scale={scale}
      rotation={rotation}
    />
  );
}
